import { cva } from 'class-variance-authority';

/**
 * Shared styling for `RadioCard` and `CheckboxCard` — visually the same
 * selectable-card treatment, applied on top of two different Radix
 * primitives (`RadioGroup.Item` vs `Checkbox.Root`).
 */
export const selectableCardVariants = cva(
  'group relative w-full rounded-lg border border-gray-500 bg-white text-left transition-colors duration-200 ease-in-out data-[state=checked]:border-green-500 data-[state=checked]:bg-green-50',
  {
    variants: {
      variant: {
        radio: 'grid grid-rows-subgrid gap-2.5 p-5 md:gap-3 md:p-6',
        checkbox:
          'flex flex-col gap-3 p-4 hover:border-green-300 md:flex-row md:items-center md:gap-4',
      },
    },
  }
);

export const selectableCardIndicatorVariants = cva(
  'flex size-6 shrink-0 items-center justify-center border border-dark-gray-100 bg-white transition-colors duration-200 ease-in-out',
  {
    variants: {
      variant: {
        radio:
          'rounded-full group-hover:border-5 group-hover:border-green-100 group-data-[state=checked]:border-7 group-data-[state=checked]:border-green-500',
        checkbox:
          'rounded group-data-[state=checked]:border-green-500 group-data-[state=checked]:bg-green-500',
      },
    },
  }
);

export const selectableCardPriceStyles =
  'font-jakarta text-1.5xl font-bold text-oxford-blue-500 md:text-2.5xl';
export const selectableCardTitleStyles = 'h4 text-oxford-blue-500';
export const selectableCardDescriptionStyles = 'caption text-dark-gray-400';
